export type ProductId = "care" | "booking" | "aivoice";

export type ProductCatalogDefinition = {
  id: ProductId;
  title: string;
  subtitle: string;
  description: string;
  modules?: string[];
};

export const PRODUCT_CATALOG: ProductCatalogDefinition[] = [
  {
    id: "care",
    title: "Plany365 Care",
    subtitle: "Care operations product",
    description:
      "Choose care listing, care jobs, or resident management tools as needed.",
    modules: [
      "Care listing",
      "Care jobs",
      "Resident Management / eMAR",
    ],
  },
  {
    id: "booking",
    title: "Booking (Timely365)",
    subtitle: "Standalone scheduling product",
    description: "Create booking pages and manage appointments.",
  },
  {
    id: "aivoice",
    title: "AI Voice",
    subtitle: "Future add-on product",
    description:
      "Voice-driven AI workflows and future phone-based automation for the Plany365 platform.",
  },
];

export function normalizeProductKey(value?: string | null): ProductId | "" {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === "care") return "care";
  if (normalized === "booking") return "booking";
  if (normalized === "aivoice" || normalized === "ai-voice" || normalized === "ai_voice") {
    return "aivoice";
  }
  return "";
}
